window.Vue = require('vue');

import utils from './helpers/utilities'
import store from './ordering-store';
import VueOffline from "vue-offline";
import isWithinInterval from 'date-fns/isWithinInterval'


import Echo from "laravel-echo"
import Pusher from "pusher-js"


window.Echo = new Echo({
    broadcaster: 'pusher',
    key: window.pusher_key,
    cluster: 'eu',
    encrypted: true,
});

require('./bootstrap')

import _ from 'lodash';


Ziggy.baseUrl = window.app_url

Lang.setLocale(language)
Vue.prototype.__ = Lang.get.bind(Lang);


Vue.prototype.__t = function(slug,replacements = {}){
    var string = window.orphans.hasOwnProperty(slug) ? window.orphans[slug] : slug;

     Object.keys(replacements).forEach((key) => {
        string = string.replaceAll(`:${key}`,replacements[key]);
    });

    return string;
}

Vue.prototype.__t_choice = function(slug, count, replacements = {}) {
    var string = window.orphans.hasOwnProperty(slug) ? window.orphans[slug] : slug;

    string = string.split('|')[count == 1 ? 0 : 1];

    Object.keys(replacements).forEach((key) => {
        string = string.replaceAll(`:${key}`,replacements[key]);
    });

    return string;
}

Vue.prototype.$utils = utils;
Vue.prototype.$app_url     = app_url;
Vue.prototype.$storage_url = storage_url;
Object.defineProperty(Vue.prototype, '$_', { value: _ });

Vue.use(VueOffline, {
    mixin: false
})


Vue.component(
    'eshop-item',
    require('./components/ordering/webapp/eshop-item.vue').default
);

Vue.component(
    'eshop-cart',
    require('./components/ordering/webapp/eshop-cart.vue').default
);

Vue.component(
    'eshop-checkout-personal',
    require('./components/ordering/webapp/eshop-checkout-personal.vue').default
);

Vue.component(
    'eshop-checkout-shipping',
    require('./components/ordering/webapp/eshop-checkout-shipping.vue').default
);

Vue.component(
    'eshop-checkout-payment',
    require('./components/ordering/webapp/eshop-checkout-payment.vue').default
);


Vue.component(
    'paypal-form',
    require('./components/ordering/webapp/common/paypal-form.vue').default
);

var app = new Vue({
    el: '#ordering-app',
    store
});


window.app = app;
